import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import AddShop from '../components/addShop';
import { saveShop } from '../actions';
import { CONFIRMATION_REQUIRED_STATUS } from '../../../main/constants';
import confirmModal from '../../../common/confirmModal';

const mapDispatchToProps = {
  saveShop,
};

export default compose(
  connect(null, mapDispatchToProps),
  withRouter,
  withHandlers({
    saveShop: props => (data) => {
      data.checkBrandCurrency = true;

      return props.saveShop(data)
        .catch((error) => {
          if (error.status === CONFIRMATION_REQUIRED_STATUS) {
            return confirmModal({
              title: '',
              message: error.message,
              type: 'yesno',
              confirmButtonText: 'Yes',
              negativeButtonText: 'No',
            }).then((confirmed) => {
              if (confirmed) {
                data.differentCurrencyConfirmed = true;

                return props.saveShop(data);
              }

              throw error;
            });
          }

          throw error;
        })
        .then(() => props.router.push('/admin/shops'));
    },
  }),
)(AddShop);

